import { getPricingApiConfig } from '../config/actions';
import { uppercaseMarketRegion } from '../../../common/utilities/uppercase-market-region';
import { buildQueryFromKeyValuePairs } from '../../../common/utilities';
/**
 * @internal
 */
export var getFetchSFCCPricesUrlGetBySkus = function (productSkus, queryParams) {
    var _a = getPricingApiConfig(), marketLocale = _a.marketLocale, baseUrl = _a.baseUrl;
    var sfccLocale = uppercaseMarketRegion(marketLocale);
    var productSkusQueryParameter = productSkus.length > 1 ? "(" + productSkus.join(',') + ")" : productSkus[0] + "/prices";
    var optionalQueryParams = queryParams ? buildQueryFromKeyValuePairs(queryParams) : '';
    return baseUrl + "/products/" + productSkusQueryParameter + "?c_method=getPrices&locale=" + sfccLocale + "&" + optionalQueryParams;
};
